import { send } from 'server';

export const setPlayerSingleBetLimits = ({ amount }) => send({
    ID: 35793,
    responses: [35794, 35795],
    description: 'Set Player Single Bet Limits',
    amount
});
